import { LegalParagraphProps } from "./types";

/**
 * 法律文件的段落組件
 * 用於顯示法律文件中的文字段落，具有一致的樣式
 */
export function LegalParagraph({ children }: LegalParagraphProps) {
  return <p className="text-base leading-loose">{children}</p>;
}
